// How the Pipeline board adapts to the screen (Pipeline proposal D-06, L4). Pure: tested in pipelineLayout.test.js.
import { PHONE_MAX } from "./quickPanel";

export const TABLET_MAX = 1023;
export const COLUMN_GAP = 16;

// phone: one column at a time, dragging off, filters in a bottom sheet; tablet: two columns snapped; desktop: columns of 280 px.
export function layoutOf(viewport) {
  if (viewport <= PHONE_MAX) return "phone";
  return viewport <= TABLET_MAX ? "tablet" : "desktop";
}

// Columns that fit side by side in the snap scroller.
export const columnsPerView = (layout) => (layout === "phone" ? 1 : layout === "tablet" ? 2 : 0);

// Index of the column the scroller is showing (the one whose left edge is the closest to the scroll position).
export function activeIndex({ scrollLeft, columnWidth, count, gap = COLUMN_GAP }) {
  if (!count || !columnWidth) return 0;
  const raw = Math.round(scrollLeft / (columnWidth + gap));
  return Math.min(Math.max(raw, 0), count - 1);
}

// Filters kept in the bottom sheet on a phone: responsible, channel, pilot, and a sort other than the default.
export function sheetFilterCount(urlView, defaultSort) {
  return ["assignee", "channel", "pilot"].filter((k) => urlView[k]).length + (urlView.sort && urlView.sort !== defaultSort ? 1 : 0);
}
